if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification ? this.cartNotification.getSectionsToRender().map((section) => section.id) : ['cart-icon-bubble'],
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification) {
            this.cartNotification.renderContents(response);
          } else {
            // Update the custom header cart badge safely without overwriting the custom icon
            if (response.sections && response.sections['cart-icon-bubble']) {
              const html = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
              const cartCountBubble = html.querySelector('.cart-count-bubble');
              
              const cartIconBtn = document.getElementById('cart-icon-bubble');
              if (cartIconBtn) {
                let badge = document.getElementById('custom-cart-count');
                if (cartCountBubble) {
                  // Cart is not empty, get the text from the span
                  const countText = cartCountBubble.querySelector('span[aria-hidden="true"]').textContent;
                  if (!badge) {
                    badge = document.createElement('div');
                    badge.className = 'custom-header__cart-badge';
                    badge.id = 'custom-cart-count';
                    const span = document.createElement('span');
                    span.setAttribute('aria-hidden', 'true');
                    badge.appendChild(span);
                    cartIconBtn.appendChild(badge);
                  }
                  badge.querySelector('span').textContent = countText;
                } else {
                  // Cart is empty, remove badge
                  if (badge) badge.remove();
                }
              }
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
